<div>
  <button mat-dialog-close type="button" mat-fab class="close-btn" (click)="close()">&times;</button>
  <mat-card class="mat-card-padding">
    <mat-card-content>
      <div class="row">
        <div *ngIf="offerCode" class="offer_code">
          <strong>{{ rGuestBookMessages?.offer?.offerModalOfferCodeText }}</strong> {{ offerCode }}
        </div>
        <h5 class="text-tile">{{ rGuestBookMessages?.offer?.offerModalSelectDatesText }}</h5>
        <div class="container">
          <div class="row">
            <div *ngIf="!isIE11" class="col-xs-12 col-sm-4 col-md-3 col-lg-3 col-sm-6 col-md-6 col-lg-6">
              <mat-form-field>
                <input
                  type="text"
                  [(ngModel)]="ArrDepDate"
                  #ctrl="ngModel"
                  [minDate]="minDate"
                  autocomplete="off"
                  (ngModelChange)="validatedates(ArrDepDate)"
                  name="date"
                  matInput
                  placeholder="{{ rGuestBookMessages?.offer?.offerModalArrDepDatePlaceholder }}"
                  readonly
                  (onShown)="onShowPicker($event)"
                  bsDaterangepicker
                  [bsConfig]="bsConfig"
                  #dpr="bsDaterangepicker" />
              </mat-form-field>
            </div>
            <div *ngIf="isIE11" class="col-xs-12 col-sm-2 col-md-2 col-lg-2">
              <mat-form-field>
                <input
                  matInput
                  #arrDate1="ngModel"
                  [(ngModel)]="IEarrival"
                  [min]="minDate"
                  (ngModelChange)="validateArrDate(IEarrival)"
                  [matDatepicker]="arrPicker"
                  placeholder="{{ rGuestBookMessages?.offer?.offerIEArrivalDatePlaceholder || 'Arrival Date' }}" />
                <mat-datepicker-toggle matSuffix [for]="arrPicker"></mat-datepicker-toggle>
                <mat-datepicker panelClass="arrDatePickerCard" #arrPicker></mat-datepicker>
              </mat-form-field>
            </div>
            <div *ngIf="isIE11" class="col-xs-12 col-sm-2 col-md-2 col-lg-2">
              <mat-form-field>
                <input
                  matInput
                  #depDate1="ngModel"
                  [(ngModel)]="IEdeparture"
                  [min]="IEarrival"
                  (ngModelChange)="validateDepDate(IEdeparture)"
                  [matDatepicker]="depPicker"
                  placeholder="{{ rGuestBookMessages?.offer?.offerIEDepartureDatePlaceholder || 'Departure Date' }}" />
                <mat-datepicker-toggle matSuffix [for]="depPicker"></mat-datepicker-toggle>
                <mat-datepicker panelClass="depDatePickerCard" #depPicker></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-xs-12 col-sm-4 col-md-3 col-lg-3">
              <button color="primary" [disabled]="!enableBook || preload" (click)="validateandmove()" mat-raised-button>
                {{ rGuestBookMessages?.offer?.offerModalShowRoomsButton }}
              </button>
              <div *ngIf="preload" class="spinnerPopup">
                <div class="rect1"></div>
                <div class="rect2"></div>
                <div class="rect3"></div>
                <div class="rect4"></div>
                <div class="rect5"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="offerError" class="panel panel-danger">
        <div class="panel-heading dialog-panel-heading">
          <p class="panel-title dialog-panel-title">{{ offerError }}</p>
        </div>
      </div>
      <div class="mat-card-content-details" *ngIf="selectedOffer">
        <div
          *ngIf="selectedOffer.quickLook == true || selectedOffer.arrivalDayFlag == true"
          class="panel panel-quickLook border border-primary custom-panel">
          <div class="panel-heading dialog-panel-heading">
            <h3 class="panel-title dialog-panel-title">{{ rGuestBookMessages?.offer?.offerModalQuickLookText }}</h3>
          </div>
          <div class="panel-body custom-panel-body">
            <div class="container-fluid">
              <ul class="row">
                <li
                  class="panel-offer-detail-li col-xs-12 col-sm-6 col-md-4 col-lg-4 loyaltyEarliestArrival"
                  *ngIf="selectedOffer.earliestArrivalDate">
                  <i class="quick_look fa fa-calendar-plus-o" aria-hidden="true"></i>
                  <p>{{ rGuestBookMessages?.offer?.offerModalEarliestArrDateText }}</p>
                  <strong>
                    <p style="color: #607d8b; font-weight: 900">
                      {{ selectedOffer.earliestArrivalDate | custDate: ConfigService?.PropertyData?.dateFunctionConfig }}
                    </p>
                  </strong>
                </li>
                <li
                  class="panel-offer-detail-li col-xs-12 col-sm-6 col-md-4 col-lg-4 loyaltyLatestArrival"
                  *ngIf="selectedOffer.latestArrivalDate">
                  <i class="quick_look fa fa-calendar-minus-o" aria-hidden="true"></i>
                  <p>{{ rGuestBookMessages?.offer?.offerModalLatestArrDateText }}</p>
                  <strong>
                    <p style="color: #607d8b; font-weight: 900">
                      {{ selectedOffer.latestArrivalDate | custDate: ConfigService?.PropertyData?.dateFunctionConfig }}
                    </p>
                  </strong>
                </li>
                <li
                  class="panel-offer-detail-li col-xs-12 col-sm-6 col-md-4 col-lg-4 loyaltyBookingStarts"
                  *ngIf="selectedOffer.earliestSalesDate">
                  <i class="quick_look fa fa-calendar-check-o" aria-hidden="true"></i>
                  <p>{{ rGuestBookMessages?.offer?.offerModalBookingStartsText }}</p>
                  <strong>
                    <p style="color: #607d8b; font-weight: 900">
                      {{ selectedOffer.earliestSalesDate | custDate: ConfigService?.PropertyData?.dateFunctionConfig }}
                    </p>
                  </strong>
                </li>
                <li
                  class="panel-offer-detail-li col-xs-12 col-sm-6 col-md-4 col-lg-4 loyaltyBookingEnds"
                  *ngIf="selectedOffer.latestSalesDate">
                  <i class="quick_look fa fa-calendar-check-o" aria-hidden="true"></i>
                  <p>{{ rGuestBookMessages?.offer?.offerModalBookingEndsText }}</p>
                  <strong>
                    <p style="color: #607d8b; font-weight: 900">
                      {{ selectedOffer.latestSalesDate | custDate: ConfigService?.PropertyData?.dateFunctionConfig }}
                    </p>
                  </strong>
                </li>
                <li class="panel-offer-detail-li col-xs-12 col-sm-6 col-md-4 col-lg-4 loyaltyMinNights" *ngIf="selectedOffer.minimumNights">
                  <i class="minimum-nights quick_look fa fa-moon-o" aria-hidden="true"></i>
                  <p>{{ rGuestBookMessages?.offer?.offerModalMinNightsText }}</p>
                  <strong>
                    <p style="color: #607d8b; font-weight: 900">
                      {{ selectedOffer.minimumNights }} {{ rGuestBookMessages?.offer?.offerModalnightsText }}
                    </p>
                  </strong>
                </li>
                <li
                  class="panel-offer-detail-li col-xs-12 col-sm-6 col-md-4 col-lg-4 loyaltyMinPurchase"
                  *ngIf="selectedOffer.minimumAdvancePurchase">
                  <i class="quick_look min-purchase fa fa-arrow-circle-o-right" aria-hidden="true"></i>
                  <p>{{ rGuestBookMessages?.offer?.offerModalMinAdvancePurseText }}</p>
                  <strong>
                    <p style="color: #607d8b; font-weight: 900">
                      {{ selectedOffer.minimumAdvancePurchase }}
                      {{ rGuestBookMessages?.offer?.offerModalDaysText }}
                    </p>
                  </strong>
                </li>
                <li
                  class="panel-offer-detail-li col-xs-12 col-sm-6 col-md-4 col-lg-4 loyaltyMaxPurchase"
                  *ngIf="selectedOffer.maximumAdvancePurchase">
                  <i class="quick_look max-purchase fa fa-arrow-circle-o-left" aria-hidden="true"></i>
                  <p>{{ rGuestBookMessages?.offer?.offerModalMaxAdvancePurseText }}</p>
                  <strong>
                    <p style="color: #607d8b; font-weight: 900">
                      {{ selectedOffer.maximumAdvancePurchase }}
                      {{ rGuestBookMessages?.offer?.offerModalDaysText }}
                    </p>
                  </strong>
                </li>
                <li class="panel-offer-detail-li col-xs-12 col-sm-6 col-md-4 col-lg-4 loyaltyMaxNights" *ngIf="selectedOffer.maximumNights">
                  <i class="maximum-nights quick_look fa fa-moon-o" aria-hidden="true"></i>
                  <p>{{ rGuestBookMessages?.offer?.offerModalMaxNightsText }}</p>
                  <strong>
                    <p style="color: #607d8b; font-weight: 900">
                      {{ selectedOffer.maximumNights }} {{ rGuestBookMessages?.offer?.offerModalnightsText }}
                    </p>
                  </strong>
                </li>
                <li
                  class="panel-offer-detail-li col-xs-12 col-sm-6 col-md-4 col-lg-4 loyaltyNoArrival"
                  *ngIf="selectedOffer.arrivalDayFlag == true">
                  <i class="quick_look fa fa-ban" aria-hidden="true"></i>
                  <p>{{ rGuestBookMessages?.offer?.offerModalNoArrivalText }}</p>
                  <div>
                    <div class="overflow_scroll">
                      <div class="day-display">
                        <h5 class="display_button" *ngIf="selectedOffer.arrivalDays[0].Monday === false">
                          {{ "Mon" | custCalDayName: CommonService?.PropertyData?.dateFunctionConfig }}
                        </h5>
                        <h5 class="display_button" *ngIf="selectedOffer.arrivalDays[0].Tuesday === false">
                          {{ "Tue" | custCalDayName: CommonService?.PropertyData?.dateFunctionConfig }}
                        </h5>
                        <h5 class="display_button" *ngIf="selectedOffer.arrivalDays[0].Wednesday === false">
                          {{ "Wed" | custCalDayName: CommonService?.PropertyData?.dateFunctionConfig }}
                        </h5>
                        <h5 class="display_button" *ngIf="selectedOffer.arrivalDays[0].Thursday === false">
                          {{ "Thu" | custCalDayName: CommonService?.PropertyData?.dateFunctionConfig }}
                        </h5>
                        <h5 class="display_button" *ngIf="selectedOffer.arrivalDays[0].Friday === false">
                          {{ "Fri" | custCalDayName: CommonService?.PropertyData?.dateFunctionConfig }}
                        </h5>
                        <h5 class="display_button" *ngIf="selectedOffer.arrivalDays[0].Saturday === false">
                          {{ "Sat" | custCalDayName: CommonService?.PropertyData?.dateFunctionConfig }}
                        </h5>
                        <h5 class="display_button" *ngIf="selectedOffer.arrivalDays[0].Sunday === false">
                          {{ "Sun" | custCalDayName: CommonService?.PropertyData?.dateFunctionConfig }}
                        </h5>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div *ngIf="selectedOffer.offerTextArray?.length" class="description_offer_calendar panel panel-offer-detail border border-primary">
          <div class="panel-heading dialog-panel-heading">
            <h3 class="panel-title dialog-panel-title">{{ rGuestBookMessages?.offer?.offerModalDescriptionText }}</h3>
          </div>
          <div class="panel-body custom-panel-body">
            <div *ngFor="let description of selectedOffer.offerTextArray">
              <p *ngIf="description?.length">
                <i class="fa fa-dot-circle-o" aria-hidden="true"></i> &nbsp;<span
                  class="offer-description"
                  [innerHtml]="description | safeHtml"></span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
